import type { Theme } from 'hephaestus/core';
import { Box, Typography } from 'hephaestus/web';
import {
  getSeverityFilterPillRootSx,
  severityFilterPillLabelSx,
} from './reconFlagsFilters.styles';
export type SeverityFilterPillProps = {
  label: string;
  active: boolean;
  onClick?: () => void;
  theme: Theme;
  inactiveBorderAndText: string;
};

export const SeverityFilterPill = ({
  label,
  active,
  onClick,
  theme,
  inactiveBorderAndText,
}: SeverityFilterPillProps) => {
  const activeBg = String(theme.color.primaryPressed ?? theme.color.primary);
  const activeHoverBg = String(theme.color.primaryHover ?? activeBg);

  return (
    <Box
      component={onClick ? 'button' : 'div'}
      {...(onClick ? { type: 'button' as const } : {})}
      onClick={onClick}
      sx={
        getSeverityFilterPillRootSx({
          theme,
          active,
          activeBg,
          activeHoverBg,
          inactiveBorderAndText,
          interactive: Boolean(onClick),
        }) as any
      }
    >
      <Typography
        component='span'
        variant='bodyMedium'
        sx={[{ fontWeight: 500 }, severityFilterPillLabelSx as any]}
      >
        {label}
      </Typography>
    </Box>
  );
};
